export default {
  API_URL: "https://api-cms.live.kkstream.io/v1",
  PLAYER_URL: "https://player.live.kkstream.io",
  EVENT_SITE_URL: "https://event.live.kkstream.io",
  CHATROOM_URL: "https://chatroom.live.kkstream.io",
};
